

































import { AsyncView } from 'client-website-ts-library/plugins';
import { API } from 'client-website-ts-library/services';
import { Component, Mixins } from 'vue-property-decorator';

import Form from '@/components/Forms/Form.vue';
import { FormConstructorData, FormField, FormValue } from 'client-website-ts-library/types/Forms';
import { Listing, ListingFileType } from 'client-website-ts-library/types/Listing';
import { ContextItemType } from 'client-website-ts-library/types/Context';

@Component({
  components: {
    Form,
  },
})
export default class ListingMakeAnOffer extends Mixins(AsyncView) {
  private listing: Listing | null = null;

  private formData: FormConstructorData | null = null;

  get pdfFiles() {
    if (!this.listing) return [];
    return this.listing.Files.filter((f) => f.Type === ListingFileType.PDF);
  }

  loadListing(listingId: string): Promise<Listing> {
    return new Promise<Listing>((resolve, reject) => {
      API.Listings.Get(listingId)
        .then((listing) => {
          this.listing = listing;

          this.formData = new FormConstructorData([
            {
              Type: ContextItemType.Listing,
              Id: this.listing.Id,
            },
          ]);

          resolve(listing);

          this.$emit('updateView');
        })
        .catch(() => {
          reject();
        });
    });
  }

  created() {
    const guidTest = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

    const idParam = this.$route.params.id;

    if (guidTest.test(idParam)) {
      this.loadListing(idParam.split('&')[0]);
    } else {
      API.Slugs.Resolve(idParam)
        .then((resolvedSlug) => {
          if (resolvedSlug.Type === 'Listing') {
            this.loadListing(resolvedSlug.Id).then((listing) => {
              if (idParam !== listing.Slug) {
                this.$router.replace(`/make-an-offer/${listing.Slug}`);
              }
            });
          } else {
            this.$router.push('/listing-not-found');
          }
        })
        .catch(() => {
          this.$router.push('/listing-not-found');
        });
    }
  }

  handleFieldInput({ def, value }: { def: FormField; value: FormValue }): void {
    const conditionalKeys = ['Buyer_2', 'Building_and_Pest', 'Finance_Clause', 'Settlement_Timeframe'];

    if (conditionalKeys.includes(value.Key)) {
      const selectedValue = value.Value;

      const allSections = document.querySelectorAll('[class*="conditional--"]');

      allSections.forEach((section) => {
        const classList = section.className;

        if (classList.includes(`conditional--${value.Key}--`)) {
          if (classList.includes(`conditional--${value.Key}--${selectedValue}`)) {
            section.classList.remove('hidden-fields');
          } else {
            section.classList.add('hidden-fields');
          }
        }
      });
    }
  }
}
